import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../../@core/utils/komunikaty-tabeli.service';
import { SumowanieKwotService } from '../../../@core/utils/sumowanie-kwot.service';
import { Platnosc } from '../../../shared/models/platnosc.model';

@Component({
  selector: 'ngx-simple-platnosci-table',
  templateUrl: './simple-platnosci-table.component.html',
  styleUrls: ['./simple-platnosci-table.component.scss'],
})
export class SimplePlatnosciTableComponent implements OnInit {

  _dane: Platnosc[];
  temp = [];
  wyswietlanieFiltrow = false;

  @Input() set dane(value: Platnosc[]) {
    if (value) {
      this.temp = [...value];
      this._dane = value;
    }
  }

  get dane(): Platnosc[] {
    return this._dane;
  }

  komunikatyTabeli: KomunikatyTabeli;
  liczbaWierszy: (cells: any[]) => string;

  constructor(
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
  ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.liczbaWierszy = this.komunikatyTabeliService.getLiczbaWierszy();
    this.translate.onLangChange.subscribe(() => {
      this.odswiezKomunikatyTabeli();
      this.liczbaWierszy = this.komunikatyTabeliService.getLiczbaWierszy();
    });
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this._dane = temp;
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d.faktura != null && d.faktura.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.dataWystawienia != null && d.dataWystawienia.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.terminPlatnosci != null && d.terminPlatnosci.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this._dane = temp;
  }

  sumaKwot(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwota || 0), 0);
  }

  sumaKwotZaplaconych(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwotaZaplacona || 0), 0);
  }

  sumaKwotPozostalych(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwotaPozostala || 0), 0);
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }
}
